import { useEffect, useState } from "react"
import {
  ContentEditV2,
  ContentPreviewV2,
  ContentTabs,
} from "./ContentV2"
import { PreviewTabType, PreviewFieldErrors } from "../QuestionPreview/types"
import QuestionDetailsV2 from "./QuestionDetailsV2"
import QuestionEditFormV2 from "./QuestionEditFormV2"
import {
  ProcessedQuestionContent,
  PreviewSubjectOption,
  PreviewQuestionValidationError,
} from "../QuestionPreview/types"

interface QuestionCardV2Props {
  content: ProcessedQuestionContent
  subjects: PreviewSubjectOption[]
  index: number
  cardIndex: number
  isPageEditing: boolean
  onChange: (name: string, value: unknown) => void
  questionValidationErrors: PreviewQuestionValidationError[]
}

const QuestionCardV2 = ({
  content,
  subjects,
  index,
  cardIndex,
  isPageEditing,
  onChange,
  questionValidationErrors,
}: QuestionCardV2Props) => {
  const fieldErrors: PreviewFieldErrors =
    questionValidationErrors.find((err) => err.index === cardIndex)?.errors ?? {}

  const [activeTab, setActiveTab] = useState<PreviewTabType>("question_result")

  useEffect(() => {
    if (fieldErrors.question) {
      setActiveTab("question_result")
    }
  }, [fieldErrors.question])

  if (isPageEditing) {
    return (
      <article className='question_preview_v2__card question_preview_v2__card--edit'>
        <header className='question_preview_v2__card-header'>
          <h3 className='question_preview_v2__card-title'>Question {index}</h3>
        </header>

        <div className='question_preview_v2__card-body'>
          <QuestionEditFormV2
            content={content}
            subjects={subjects}
            onChange={onChange}
            fieldErrors={fieldErrors}
          />

          <section className='question_preview_v2__content'>
            <div className='question_preview_v2__content-inner'>
              <ContentEditV2
                cardIndex={cardIndex}
                content={content}
                onChange={onChange}
                questionError={fieldErrors.question}
                activeTab={activeTab}
                onTabChange={setActiveTab}
              />
            </div>
          </section>
        </div>
      </article>
    )
  }

  return (
    <div className='single_question'>
      <div className='left'>
        <div className='header'>
          <div className='left_menu'>
            <div className='index'>{index}</div>
            <div className='tags'>
              <div className='tag'>{content.topic || "—"}</div>
              <div className='tag'>{content?.complexity || "—"}</div>
            </div>
          </div>

          <div className='right_menu'>
            <ContentTabs
              activeTab={activeTab}
              onTabChange={setActiveTab}
              className='question_preview_v2__tabs question_preview_v2__tabs--inline'
            />
          </div>
        </div>

        <ContentPreviewV2 content={content} activeTab={activeTab} />
      </div>

      <QuestionDetailsV2 content={content} subjects={subjects} />
    </div>
  )
}

export default QuestionCardV2
